import React, { useMemo } from 'react';
import { string, number, arrayOf, shape } from 'prop-types';
import * as styles from './styles/styles.module.scss';
import River from '../../shared/River';
import ShopifyCard from './ShopifyCard';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { HOME_PAGE_WIDTH_BREAKPOINT, DESKTOP_BREAKPOINT } from '../../../utils/constants/breakpoints';

const slickSettings = { slidesToShow: 4, lazyLoad: 'progressive', slidesToScroll: 4, speed: 750 };

const {
  strings: {
    HOME_PAGE: {
      SHOPIFY_BLOCK: { SHARE_THE_LOVE, VISIT_THE_STORE }
    }
  }
} = StringConstantsMixin;

const ARROW_STYLES = { next: styles.next, previous: styles.previous };

const ShopifyPreview = ({ shopifyProducts, windowWidth, page }) => {
  const formattedProducts = useMemo(() => {
    // In the past Shopify has sent down [null] in the `images` array
    // so we filter the products to protect against that
    return shopifyProducts
      .filter(({ images }) => images.length > 0 && !!images[0])
      .map(({ images, title, shopItemUrl, price }) => {
        return {
          image: {
            src: images[0].src,
            altText: images[0].alt
          },
          title,
          shopItemUrl,
          price
        };
      });
  }, [shopifyProducts]);

  const trackClick = () => {
    _gaq.push(['_trackEvent', page, 'visit-store', 'clicked']);
  };

  const visitTheStore = useMemo(() => {
    return (
      <a href="https://shop.alltrails.com" target="_blank" className={styles.storeLink} onClick={trackClick}>
        {VISIT_THE_STORE}
      </a>
    );
  }, []);

  const isMobile = useMemo(() => {
    return windowWidth && windowWidth < DESKTOP_BREAKPOINT;
  }, [windowWidth]);

  const isWideScreen = useMemo(() => {
    return windowWidth && windowWidth >= HOME_PAGE_WIDTH_BREAKPOINT;
  }, [windowWidth]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>{SHARE_THE_LOVE}</div>
        {!isMobile && visitTheStore}
      </div>
      <div className={styles.riverContainer}>
        <River useSlick={isWideScreen} slickSettings={slickSettings} className={`${styles.riverClass} xlate-none`} arrowStyles={ARROW_STYLES}>
          {formattedProducts.map(product => {
            return <ShopifyCard key={product.title} {...product} />;
          })}
        </River>
        {isMobile && visitTheStore}
      </div>
    </div>
  );
};

ShopifyPreview.propTypes = {
  windowWidth: number,
  shopifyProducts: arrayOf(shape({ images: arrayOf(shape({ src: string, alt: string })), title: string, shopItemUrl: string, price: string })),
  page: string
};

ShopifyPreview.defaultProps = {
  windowWidth: null,
  shopifyProducts: [],
  page: ''
};

export default ShopifyPreview;
